import { gemmiciApiServiceClient } from "../../../core/apis/gemmiciApiService/AxiosIntance";
import qs from "qs";

export default {
  retrieveCityAPI({ longitude, latitude, shortName: name } = {}) {
    return gemmiciApiServiceClient.get("cities", {
      params: {
        coordinates: [longitude, latitude],
        name
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  retrieveDepartmentAPI(name, longitude, latitude) {
    return gemmiciApiServiceClient.get("departments", {
      params: {
        coordinates: [longitude, latitude],
        name: name
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  retrieveRegionAPI(name, longitude, latitude) {
    return gemmiciApiServiceClient.get("regions", {
      params: {
        coordinates: [longitude, latitude],
        name: name
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  retrieveAdministrativeAPI(name, longitude, latitude) {
    return gemmiciApiServiceClient.get("administratives", {
      params: {
        coordinates: [longitude, latitude],
        name: name
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  locationSearchAPI(location) {
    return gemmiciApiServiceClient.get("search/geocoding", {
      params: {
        location: location
      }
    });
  },
  retrieveCityBorderAPI({ longitude, latitude, shortName: name } = {}) {
    return gemmiciApiServiceClient.get("border/cities", {
      params: {
        coordinates: [longitude, latitude],
        name
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  retrieveDepartmentBorderAPI({ longitude, latitude, shortName: name } = {}) {
    let coordinates = [];
    longitude && latitude ? (coordinates = [longitude, latitude]) : 0;
    return gemmiciApiServiceClient.get("border/departments", {
      params: {
        coordinates: coordinates,
        name
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  retrieveRegionBorderAPI({ longitude, latitude, shortName: name } = {}) {
    let coordinates = [];
    longitude && latitude ? (coordinates = [longitude, latitude]) : 0;
    return gemmiciApiServiceClient.get("border/regions", {
      params: {
        coordinates: coordinates,
        name
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  retrieveAdministrativeBorderAPI({
    longitude,
    latitude,
    shortName: name
  } = {}) {
    let coordinates = [];
    longitude && latitude ? (coordinates = [longitude, latitude]) : 0;
    return gemmiciApiServiceClient.get("border/administratives", {
      params: {
        coordinates: coordinates,
        name
      },
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  }
};
